export type WorkflowPipelineActionType =
  | 'CHANGE_DEAL_STAGE'
  | 'UPDATE_DEAL_CLOSE_DATE'
  | 'CHANGE_PIPELINE'
  | 'CHANGE_TICKET_STATUS'
  | 'CHANGE_TICKET_PRIORITY'
  | 'CHANGE_TICKET_PIPELINE';

export interface WorkflowPipelineActionRequest {
  actionType: WorkflowPipelineActionType;
  objectType: string;
  objectId?: number;
  config: Record<string, any>;
  context?: Record<string, any>;
}

export interface WorkflowPipelineActionResponse {
  actionType?: string;
  status?: string;
  message?: string;
  targetObjectType?: string;
  targetObjectId?: number;
  output?: Record<string, any>;
  error?: Record<string, any>;
  warnings?: string[];
}

export interface WorkflowPipelinePreviewRequest {
  enrollmentId?: number;
  actionType: WorkflowPipelineActionType;
  config: Record<string, any>;
  context?: Record<string, any>;
}

export interface WorkflowPipelinePreviewResponse {
  actionType?: string;
  targetObjectType?: string;
  targetObjectId?: number;
  message?: string;
  output?: Record<string, any>;
  warnings?: string[];
}

export const PIPELINE_ACTION_TEST_EXAMPLES: Record<string, {
  config: Record<string, any>;
  context: Record<string, any>;
  objectType: string;
}> = {
  CHANGE_DEAL_STAGE: {
    objectType: 'DEAL',
    config: {
      dealIdSource: 'CURRENT_RECORD',
      targetStageId: 4,
      reason: 'Avance automático por workflow',
      continueOnError: false
    },
    context: { deal: { id: 1, stageId: 1 } }
  },
  UPDATE_DEAL_CLOSE_DATE: {
    objectType: 'DEAL',
    config: {
      dealIdSource: 'CURRENT_RECORD',
      mode: 'RELATIVE',
      amount: 30,
      unit: 'DAYS',
      timezone: 'America/Lima',
      reason: 'Extensión automática',
      continueOnError: false
    },
    context: { deal: { id: 1 } }
  },
  CHANGE_PIPELINE: {
    objectType: 'DEAL',
    config: {
      dealIdSource: 'CURRENT_RECORD',
      targetPipelineId: 1,
      targetStageId: 7,
      preserveStageIfPossible: false,
      reason: 'Cambio a pipeline lógico',
      continueOnError: false
    },
    context: { deal: { id: 1 } }
  }
};

export const TICKET_PIPELINE_ACTIONS: WorkflowPipelineActionType[] = [
  'CHANGE_TICKET_STATUS',
  'CHANGE_TICKET_PRIORITY',
  'CHANGE_TICKET_PIPELINE'
];
